import React from "react";
import Files from "../foldersComponent/files";
const MapMore = (props) => {
  return (
    <div className="map-more-files">
      {props.moreFiles && props.moreFiles.length > 0 ?
        <Files list={props.moreFiles} />
        : null}
    </div>
  )

}
export default MapMore;


// WEBPACK FOOTER //
// ./src/components/mapPreview/mapMore.js